
/*this pipe converts the selected concept object to an array of objects and then sorts that array - ASC or DESC
Props:
	selectedConcepts: (objecy) the object to be converted to an array and then sorted
	sortBy: (string) the key of the value to sort by
	direction: (string) the direction of the sort - ASC or DESC
*/
export function convertSortSelectedConceptsPipe (props) {
	let { selectedConcepts, sortBy, direction } = props,
		sorted;

	if ( selectedConcepts == undefined ) {
		return sorted;
	}

	//if not array, convert to array
	if (!Array.isArray(selectedConcepts)) {
		selectedConcepts = Object.values(selectedConcepts);
	}

	//if no sort by, then return list as is.
	if (sortBy == undefined || sortBy == '') {
		return selectedConcepts;
	}
	
	sorted = selectedConcepts.sort( function(a, b) {
		return  a[sortBy].localeCompare(b[sortBy], undefined, {numeric: true}) ;
	});
	//if decending set, reverse
	if (direction == 'DESC') {
		sorted.reverse();
	}

	return sorted;
}

